// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1aqvU","colBig":"styles_colBig__1GnDi","colSmall":"styles_colSmall__n2RmV"};